import { gql } from '@apollo/client';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @fragment AccountFragment
 * @since 1.0.0
 */
export const AccountFragment = gql `
  fragment AccountFragment on Account {
    id
    name
    host
    href
    tag
    type
    number
    options
    industry
    employes
    timezone
    civicNumber
    road
    country
    province
    postalcode
    city
    contactName
    contactRole
    contactPhone
    contactEmail
    website
    active
    type
    createdAt
    updatedAt
    signatureDate
    activationDate
    expirationDate

    logo {
      ...MediaFragment
    }

    icon {
      ...MediaFragment
    }

    linkedAccounts {
      id
      name
      logo {
        ...MediaFragment
      }
    }

    configs {
      id
      fieldKey
      value
      category
    }

    modules {
      id

      module {
        id
        tag
        title
      }

      actions {
        id
        value
        title
      }
    }
  }

  ${MediaFragment}
`;
